import { css } from 'emotion';
import { mobileMaxWidthBreakpoint } from 'inside-out/global-styles';

export const wrapperStyle = css({
	width: 255,
	overflow: 'hidden',
	borderRadius: 6,
	boxShadow: '0 10px 15px 5px rgba(0,0,0,0.2)',

	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		width: '100%',
		flexGrow: 1,
		marginRight: 0,
	}
});

export const itemStyle = active => css({
	height: 54,
	padding: '0 22px',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	backgroundColor: active ? '#f4f4f4' : '#fff',
	cursor: 'pointer',

	['&:hover']: {
		backgroundColor: '#f4f4f4',
	},

	['& > span']: {
		marginLeft: 20,
		fontSize: 14,
		color: '#000',
		fontWeight: 500,
	}
})


// WEBPACK FOOTER //
// ./src/components/resource-library/audienceFilter/styles.js